import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  height: 100%;
`;

class BlankLayout extends React.PureComponent {
  render() {
    return <PageContainer>{this.props.children}</PageContainer>;
  }
}

export default BlankLayout;



// WEBPACK FOOTER //
// ./src/components/layout/BlankLayout/index.js